import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-semibold text-secondary-600">
            <i className="ri-question-line"></i> 吃瓜 FAQ
          </p>
          <h2 className="serif-title mt-2 text-3xl font-black text-foreground-950 md:text-4xl">
            关于吃瓜，你可能想问
          </h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${isOpen ? "border-secondary-300 bg-background-50" : "border-background-200 bg-background-50"}`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="serif-title text-base font-bold text-foreground-900">{f.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? "bg-secondary-600 text-background-50" : "bg-background-100 text-foreground-500"}`}>
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}